import React from 'react';
import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import Heading from '@atlaskit/heading/heading';
import { Box } from '@atlaskit/primitives/compiled/box';

import { ErrorDetail } from '@confluence/error-boundary/entry-points/ErrorDetail.ts';
import type { ErrorComponentProps } from '@confluence/error-boundary/entry-points/GenericErrorBoundary.ts';
import { HOME_OVERVIEW_RECENT_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { ExperienceStop } from '@confluence/experience-tracker/entry-points/component.ts';
import { fg } from '@confluence/feature-gating';

import { i18n } from '../Error.tsx';
import SearchErrorImage from '../images/SearchErrorImage.svg';

const errorContainerStyles = css({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	width: '100%',
	padding: '32px 20px',
});

const errorImageStyles = css({
	width: '100px',
	height: 'auto',
});

export const RecentListError = ({ error }: ErrorComponentProps): React.JSX.Element => (
	<div css={errorContainerStyles}>
		<img src={SearchErrorImage} alt="" css={errorImageStyles} />
		<Heading size="small">
			<FormattedMessage {...i18n.errorHeader} />
		</Heading>
		<Box paddingBlockStart="space.100">
			<FormattedMessage {...i18n.errorAction} />
		</Box>
		<Box paddingBlockStart="space.100">
			<ErrorDetail />
		</Box>
		{/* The crashed RecentList can no longer stop this experience, so fail it with the caught error. */}
		{/* eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred. */}
		{fg('confluence_home_recent_experience_leak_fix') && (
			<ExperienceStop name={HOME_OVERVIEW_RECENT_EXPERIENCE} error={error} />
		)}
	</div>
);
